// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.route-title-icon[data-v-5da4cfa4] {\n  width: 43px;\n  height: 43px;\n  padding: 5px;\n  border-radius: 50%;\n  border: 1px solid #edf5f4;\n}\nh2[data-v-5da4cfa4] {\n  color: var(--green);\n  font-size: 2.05rem;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
